export default __webpack_public_path__ + "static/media/otp-verify.51887c65.svg";